module.exports = __webpack_public_path__ + "media/images/icons/icon-filter-list-60cc64007e65b38de4fd3d2982e7ae0d.svg";